import { useState } from 'react';
import { ClickAwayListener, IconButton, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

type Props = {
    text: string;
};

/**
 * Icono de ayuda junto a un campo de formulario: muestra `text` al pasar por
 * encima y también al pinchar, para que funcione en pantallas táctiles.
 */
export default function FieldHelp({ text }: Props): React.ReactElement {
    const [open, setOpen] = useState(false);

    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Tooltip
                title={text}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                arrow
            >
                <IconButton size="small" onClick={() => setOpen(!open)}>
                    <HelpOutline fontSize="small" />
                </IconButton>
            </Tooltip>
        </ClickAwayListener>
    );
}
